<template>
  <div class="adminUserList">
      <Breadcumb :title="$t('companies')" :breadcumb-data="breadcumbData">
<!--        <b-btn v-bind:to="'/company/add/'" class="mt-3 mb-3" variant="primary" style="float:right">-->
<!--          {{ $t('add_company') }}-->
<!--        </b-btn>-->
      </Breadcumb>
    <b-card no-body class="cardcontainer">
      <!-- Table controls -->
      <b-card-body>
        <v-jstree
                :data="treeData"
                :item-events="companies"
                :class="{ 'tree-rtl': isRTL }"
                multiple
                allow-batch
                whole-row
                draggable/>
      </b-card-body>

    </b-card>
  </div>
</template>
<style src="@/vendor/libs/vue-jstree/vue-jstree.scss" lang="scss"></style>
<script>
  import {GET_COMPANIES_REQUEST, GET_HIERARCHICAL_COMPANIES_REQUEST} from '../_store/company/actiontypes'
  import Breadcumb from '../components/breadcumb'
  import VJstree from 'vue-jstree'
  

  function getChildrens(company) {
    return company.companies.map(children => {
      let opened = false;
      if (company.type === "BRANCH")
        opened = true;
      if (children.companies.length > 0) {
        return {
          'checkable': false,
          'show-checkbox': false,
          'text': children.name,
          'id': children.id,
          'selected': false,
          'children': getChildrens(children),
          'opened': opened,
        }
      } else {
        return {
          'checkable': false,
          'show-checkbox': false,
          'text': children.name,
          'id': children.id,
          'selected': false,
          'children': [],
          'opened': opened,
        }
      }
    
    })
  }

  export default {
    name: 'adminUserList',
    components: { Breadcumb, VJstree },
    mounted() {
      this.$store.dispatch(GET_HIERARCHICAL_COMPANIES_REQUEST)
            .then(response => {
              this.treeData = response.data.hierarchical_companies.map(company => {
                let childrens = [];
                if (company.companies.length > 0) {
                  childrens = getChildrens(company)
                }
                return {
                  'show-checkbox': false,
                  'text': company.name,
                  'id': company.id,
                  'children': childrens,
                  'opened': true,
                }
              });
              console.log(this.treeData);
            });
    },
    data() {
      return {
        treeData: [],
        breadcumbData: [
          { text: this.$t('welcome'), href: '/dashboard/' },
          { text: this.$t('companies'), active: true },
        ],
        dataUrl: 'json/pages_users_list.json',
        fields: [
          {
            key: 'Nom',
            sortable: false,
            tdClass: 'align-middle'
          }, {
            key: 'Code',
            sortable: false,
            tdClass: 'align-middle'
          },
          {
            key: 'Branche',
            sortable: false,
            tdClass: 'align-middle'
          },
          {
            key: 'Direction Région',
            sortable: false,
            tdClass: 'align-middle'
          },
          {
            key: 'Affectation / Filiale',
            sortable: false,
            tdClass: 'align-middle'
          },
          {
            key: 'Société',
            sortable: false,
            tdClass: 'align-middle'
          },
          {
            key: 'Secteur',
            sortable: false,
            tdClass: 'align-middle'
          },
        ],
        companiesData: [],
        currentPage: 1
      };
    },
    layout(context) {
      return 'layout';
    },
    methods: {},
  };
</script>
